module.exports = __webpack_public_path__ + "img/star.cc8be611.png";